window.addEventListener("load", function () {
  var now = new Date().getTime();

  var lastTriggerTime = localStorage.getItem("lastTriggerTime");

  if (lastTriggerTime === null || now - lastTriggerTime > 24 * 60 * 60 * 1000) {
    var promoModal = document.getElementById("promoModalTrigger");
    if (promoModal !== null) {
      try {
        promoModal.click();
        localStorage.setItem("lastTriggerTime", now);
      } catch (e) {
        console.log(e);
      }
    }
  }
  if (this.document.querySelector("#promoModal .promo-button") !== null) {
    document
      .querySelector("#promoModal .promo-button")
      .addEventListener("click", function () {
        document.querySelector("#promoModal .btn-close").click();
      });
  }
});
